import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	align-items: flex-start;
	margin: 0;
	width: 100%;
`;
